export default {"src":"https://wp-static.smartkarma.com/_next/static/media/recently-visited.3b175ed5.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};